<template>
  <div class="home_box">
   

    <!-- 内容区域 -->
    <div class="main_container">
      <!-- 左侧栏目 -->
      <aside class="sidebar">
        <div class="logo">
          <img src="@/assets/logo (2).png" alt="甜筒星球" class="logo_img" />
        </div>
        <!-- 搜索框 -->
        <div class="search_box">
          <img style="width: 16px; margin-right: 6px;" src="../assets/sousuo2.png" alt="">
          <input type="text" placeholder="搜索内容" class="search_input" />
        </div>

        <!-- 菜单列表 -->
        <ul class="menu_list">
          <li
            v-for="item in menuList"
            :key="item.name"
            :class="['menu_item', { active: activeMenu === item.name }]"
            @click="lanmu(item)"
          >
            <img 
              class="menu_icon" 
              :src="activeMenu === item.name ? item.iconActive : item.icon" 
              alt=""
            >
            <span class="menu_text">{{ item.label }}</span>
          </li>
        </ul>

        <!-- 登陆按钮 -->
        <button class="sidebar_login_btn" @click="$router.push('/login')">登陆</button>

        <!-- 推荐主播 -->
        <div class="recommend_section">
          <h3 class="section_title">推荐主播</h3>
          <ul class="anchor_list">
            <li v-for="anchor in anchorList" :key="anchor.id" class="anchor_item">
              <div class="anchor_avatar_wrap">
                <img :src="anchor.avatar" :alt="anchor.name" class="anchor_avatar" />
                <span v-if="anchor.isLive" class="live_badge">直播中</span>
              </div>
              <div class="anchor_info">
                <span class="anchor_name">{{ anchor.name }}</span>
                <span class="anchor_tag">{{ anchor.tag }}</span>
              </div>
            </li>
          </ul>
        </div>

        <!-- 公司信息 -->
        <div class="company_section">
          <div class="company_links">
            <a href="#" class="company_link">公司</a>
            <a href="#" class="company_link">计划</a>
            <a href="#" class="company_link">条款和政策</a>
          </div>
          <p class="company_copyright">© 2026 北京甜筒星球科技有限公司 版权所有</p>
        </div>
      </aside>

      <!-- 视图展示区域 -->
      <main class="content">
        <router-view></router-view>
      </main>
    </div>

    <!-- 充值弹窗 -->
    <div v-if="vipshow" class="recharge-overlay" @click.self="closeRecharge">
      <div class="recharge-panel">
        <!-- 头部 -->
        <div class="recharge-header">
          <h3 class="recharge-title">获取甜筒·充值</h3>
          <i class="el-icon-close" @click="closeRecharge"></i>
        </div>

        <!-- 充值选项 -->
        <div class="recharge-options">
          <div
            v-for="(item, index) in rechargeList"
            :key="index"
            class="recharge-item"
            :class="{ active: selectedAmount === item.amount }"
            @click="selectAmount(item)"
          >
            <div class="item-left">
              <img src="@/assets/tiantong.png" class="sweet-icon" alt="甜筒" />
              <span class="sweet-count">{{ item.count }}甜筒</span>
            </div>
            <span class="item-price">{{ item.amount }}元</span>
          </div>

          <!-- 自定义 -->
          <div class="recharge-item custom-item">
            <div class="item-left">
              <img src="@/assets/TT_logo.png" class="sweet-icon" alt="甜筒" />
              <span class="sweet-count">自定义</span>
            </div>
            <input
              v-model="customAmount"
              type="number"
              placeholder="xx"
              class="custom-input"
              @focus="selectedAmount = null"
            />
            <span class="custom-unit">元</span>
          </div>
        </div>

        <!-- 底部说明 -->
        <div class="recharge-footer">
          <p class="recharge-tips">甜筒将在支付成功后即时到账<br>账单显示：甜筒星球充值</p>
          <button class="btn-recharge" @click="confirmRecharge">充值</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'homeT',
  data() {
    return {
      // 当前选中的导航
      activeNav: 'music',
      // 当前选中的菜单
      activeMenu: 'home',
      // 充值相关
      selectedAmount: 90,
      customAmount: '',
      rechargeList: [
        { count: 1, amount: 1 },
        { count: 30, amount: 10 },
        { count: 90, amount: 90 },
        { count: 100, amount: 100 },
        { count: 6000, amount: 648 }
      ],
      // 导航列表
      navList: [
        { name: 'music', label: '音乐' },
        { name: 'instrument', label: '乐器' },
        { name: 'dance', label: '舞蹈' },
        { name: 'talkshow', label: '脱口秀' },
        { name: 'anime', label: '二次元' },
        { name: 'beauty', label: '颜值' },
        { name: 'talent', label: '才艺' },
        { name: 'lifestyle', label: '生活方式' },
        { name: 'groupdance', label: '团舞' },
        { name: 'cover', label: '翻唱' }
      ],
      // 左侧菜单列表
      menuList: [
        { name: 'home', label: '首页', icon: require('../assets/shoye_hui.png'), iconActive: require('../assets/shoye.png')},
        { name: 'discover', label: '发现精彩', icon:require('../assets/zhibo_hui.png'), iconActive:require('../assets/zhibo.png')},
        { name: 'live', label: '开启直播', icon: require('../assets/shipin_hui.png'), iconActive: require('../assets/shipin.png')},
        { name: 'settings', label: '设置', icon: require('../assets/gengduo_hui.png'), iconActive: require('../assets/gengduo.png')}
      ],
      // 推荐主播列表
      anchorList: [
        {
          id: 1,
          name: '深夜电台',
          tag: '🎀爱笑青青🎀',
          avatar: 'https://via.placeholder.com/40',
          isLive: true
        },
        {
          id: 2,
          name: '治愈系美食',
          tag: '图图妈',
          avatar: 'https://via.placeholder.com/40',
          isLive: true
        },
        {
          id: 3,
          name: '唱歌跳舞打篮球',
          tag: 'ukun',
          avatar: 'https://via.placeholder.com/40',
          isLive: true
        },
        {
          id: 4,
          name: '号主限时回归！',
          tag: '今天不画大饼🌻',
          avatar: 'https://via.placeholder.com/40',
          isLive: true
        }
      ]
    }
  },
  methods:{
    lanmu(item){
      this.activeMenu = item.name;
      if(item.name === 'settings'){
        this.$router.push('/shezhi');
      } else if(item.name === 'home'){
        this.$router.push('/');
      } else if(item.name === 'discover'){
        this.$router.push('/fx');
      } else if(item.name === 'live'){
        this.$router.push('/kaibo');
      }
    },
    // 选择充值金额
    selectAmount(item) {
      this.selectedAmount = item.amount
      this.customAmount = ''
    },
    // 关闭充值弹窗
    closeRecharge() {
      this.$store.commit('setVipshow', false)
    },
    // 确认充值
    confirmRecharge() {
      const amount = this.selectedAmount || this.customAmount
      if (!amount) {
        this.$message.error('请选择或输入充值金额')
        return
      }
      this.$message.success(`充值${amount}元成功`)
      this.closeRecharge()
    }
  },
  computed: {
    vipshow() {
      return this.$store.state.vipshow
    }
  }
}
</script>

<style scoped>
/* ==================== 整体布局 ==================== */
.home_box {
  min-height: 100vh;
  background-color: #FBFAFF;
}

/* ==================== 顶部导航栏 ==================== */
.header {
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 24px;
  background-color: #FFFFFF;
  /* border-bottom: 1px solid #DED5FF; */
}

/* Logo区域 */
.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 230px;
  margin-bottom:20px
}

.logo_img {
  width: 135px;
  margin-right: 8px;
}

.logo_text {
  font-size: 20px;
  font-weight: 600;
  color: #8A3FFC;
}

/* 导航区域 */
.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  padding-right: 16px;
}

.nav_item {
  padding: 8px 12px;
  font-size: 14px;
  color: #4B3B73;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  position: relative;
}

.nav_item:hover {
  color: #8A3FFC;
}


.nav_item.active {
  color: #8A3FFC;
  font-weight: 500;
}

.nav_item.active::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 24px;
  height: 3px;
  background-color: #8A3FFC;
  border-radius: 2px;
}

/* 更多按钮 */
.nav_more {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-left: 8px;
  color: #7C6AAE;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.nav_more:hover {
  background-color: #ECE6FF;
}

/* 登陆按钮 */
.login_btn {
  margin-left: auto;
  padding: 8px 24px;
  font-size: 14px;
  color: #8A3FFC;
  background-color: transparent;
  border: 1px solid #8A3FFC;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.login_btn:hover {
  color: #FFFFFF;
  background-color: #8A3FFC;
}

/* ==================== 主内容区域 ==================== */
.main_container {
  display: flex;
  height: calc(100vh);
}

/* ==================== 左侧栏目 ==================== */
.sidebar {
  display: flex;
  flex-direction: column;
  /* width: 240px; */
  padding: 20px 16px;
  background-color: #FFFFFF;
  /* border-right: 1px solid #DED5FF; */
  overflow-y: auto;
}

/* 搜索框 */
.search_box {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  margin-bottom: 16px;
  background-color: #F9F7FF;
  border-radius: 24px;
}

.search_icon {
  margin-right: 8px;
  font-size: 16px;
  color: #9B8DC7;
}

.search_input {
  flex: 1;
  font-size: 14px;
  color: #5B4B7A;
  background: transparent;
  border: none;
  outline: none;
}

.search_input::placeholder {
  color: #9B8DC7;
}

/* 菜单列表 */
.menu_list {
  margin-bottom: 16px;
}

.menu_item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  margin-bottom: 4px;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.menu_item:hover {
  background-color: #F9F7FF;
}

.menu_item.active {
  background-color: #ECE6FF;
}

.menu_icon {
  margin-right: 12px;
  width: 20px;
  height: 20px;
  object-fit: contain;
  vertical-align: middle;
}

.menu_text {
  font-size: 14px;
  color: #9B8DC7;
  vertical-align: middle;
  line-height: 20px;
}

.menu_item.active .menu_text {
  color: #8A3FFC;
  font-weight: 500;
}



/* 侧边栏登陆按钮 */
.sidebar_login_btn {
  width: 100%;
  padding: 12px 0;
  margin-bottom: 24px;
  font-size: 14px;
  color: #FFFFFF;
  background: linear-gradient(135deg, #8A3FFC 0%, #A855F7 100%);
  border: none;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sidebar_login_btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

/* 推荐主播区域 */
.recommend_section {
  padding-top: 16px;
  border-top: 1px solid #DED5FF;
}

.section_title {
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #181426;
}

.anchor_list {
  list-style: none;
}

.anchor_item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  cursor: pointer;
}

.anchor_avatar_wrap {
  position: relative;
  width: 44px;
  height: 44px;
  margin-right: 12px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #8A3FFC;
}

.anchor_avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.live_badge {
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  padding: 2px 6px;
  font-size: 10px;
  color: #FFFFFF;
  background: linear-gradient(135deg, #ff4040 0%, #ff3b3b 100%);
  border-radius: 8px;
  white-space: nowrap;
}

.anchor_info {
  display: flex;
  flex-direction: column;
}

.anchor_name {
  font-size: 14px;
  font-weight: 500;
  color: #4B3B73;
  margin-bottom: 2px;
}

.anchor_tag {
  font-size: 12px;
  color: #9B8DC7;
}

/* 公司信息区域 */
.company_section {
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid #DED5FF;
}

.company_links {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.company_link {
  font-size: 12px;
  color: #9B8DC7;
  text-decoration: none;
  transition: color 0.3s ease;
}

.company_link:hover {
  color: #8A3FFC;
}

.company_copyright {
  font-size: 12px;
  color: #9B8DC7;
}

/* ==================== 充值弹窗 ==================== */
.recharge-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
}

.recharge-panel {
  width: 360px;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.recharge-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;

  .recharge-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }

  .el-icon-close {
    font-size: 20px;
    color: #999;
    cursor: pointer;

    &:hover {
      color: #666;
    }
  }
}

.recharge-options {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
}

.recharge-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  margin-bottom: 12px;
  background: #f8f8ff;
  border: 2px solid transparent;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #f0f0ff;
  }

  &.active {
    background: #8B5CF6;
    border-color: #8B5CF6;

    .sweet-count,
    .item-price {
      color: #fff;
    }
  }

  .item-left {
    display: flex;
    align-items: center;
    gap: 12px;

    .sweet-icon {
      width: 24px;
      height: 33px;
    }

    .sweet-count {
      font-size: 15px;
      color: #333;
      font-weight: 500;
    }
  }

  .item-price {
    font-size: 15px;
    color: #333;
    font-weight: 500;
  }
}

.custom-item {
  .custom-input {
    width: 60px;
    padding: 4px 8px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 14px;
    text-align: center;
    outline: none;
    background: #fff;

    &:focus {
      border-color: #8B5CF6;
    }
  }

  .custom-unit {
    font-size: 14px;
    color: #666;
    margin-left: 4px;
  }
}

.recharge-footer {
  padding: 20px 24px;
  border-top: 1px solid #f0f0f0;

  .recharge-tips {
    font-size: 12px;
    color: #999;
    text-align: center;
    margin: 0 0 16px 0;
    line-height: 1.6;
  }

  .btn-recharge {
    width: 100%;
    padding: 14px 0;
    background: #8B5CF6;
    border: none;
    border-radius: 28px;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.9;
    }
  }
}

/* ==================== 内容区域 ==================== */
.content {
  flex: 1;
  /* padding: 24px 0; */
  overflow-y: auto;
  background-color: #FBFAFF;
}
</style>
